import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { notification } from 'antd';
import { useFetch } from './useFetch';
import { IListResponse } from '../types/list';
import { INotification } from '../types/notification';

export const useNotifications = () => {
    const listFetch = useFetch();
    const [data, setData] = useState<IListResponse<INotification>>();
    const [searchParams] = useSearchParams();
    const { i18n, t } = useTranslation();
    const page = searchParams.get('page');
    const search = searchParams.get('search');

    const getList = async () => {
        let url = '/notifications';

        if (typeof page === 'string') {
            url += `?page=${page}`;
        }

        const result = await listFetch.request<IListResponse<INotification>>({
            url,
            method: 'post',
            data: {
                search: typeof search === 'string' && search.length > 0 ? search : undefined,
                sorters: [{ column: 'id', desc: true }],
            },
        });

        if (result.success && result.data) {
            setData(result.data);
        }
    };

    const resend = async (record: INotification) => {
        const response = await listFetch.request({ url: `/notifications/${record.id}/resend` });
        notification[response.success ? 'success' : 'error']({
            message: response.message || t('httpRequestUnexpectedError'),
        });
        getList();
    };

    useEffect(() => {
        getList();
    }, [page, search, i18n.language]);

    return {
        data,
        loading: listFetch.loading,
        resend,
    };
};
